
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/terms-of-use",
      function () {
        return require("private-next-pages/help/terms-of-use/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/terms-of-use"])
      });
    }
  